import { SalesOrder } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1391. 受注案件管理会計モード切替
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/update_accounting_manual_mode
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  accounting_manual_mode: boolean;
};
const updateSalesOrderAccountingManualMode = (props: Props): Promise<SalesOrder> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/update_accounting_manual_mode`,
    props
  );
};

export const useUpdateSalesOrderAccountingManualMode = () => {
  return useMutation({
    mutationFn: updateSalesOrderAccountingManualMode
  });
};